// サーバーの時刻の読み方（Issue #966）。
// DB はタイムゾーン無しの TIMESTAMP に UTC を入れ、API は isoformat（オフセット無し）で返す。
// `new Date('2026-10-28T03:00:00')` は端末の時刻として読むので、オフセットの無い文字は UTC として読む。

const NAIVE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

/** サーバーの時刻（文字・ミリ秒・Date）→ Date。読めなければ null */
export function parseServerTime(v) {
  if (v === null || v === undefined || v === '') return null;
  if (v instanceof Date) return Number.isFinite(v.getTime()) ? v : null;
  if (typeof v === 'number') return new Date(v);
  const s = String(v).trim();
  const t = new Date(NAIVE.test(s) ? `${s.replace(' ', 'T')}Z` : s);
  return Number.isFinite(t.getTime()) ? t : null;
}

/** ミリ秒。読めなければ null */
export function serverTimeMs(v) {
  const t = parseServerTime(v);
  return t ? t.getTime() : null;
}

/** 日本時間の日時の文字（toLocaleString('ja-JP')）。読めなければ '' */
export function formatServerTime(v, options) {
  const t = parseServerTime(v);
  return t ? t.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo', ...options }) : '';
}

/** 日本時間の日付の文字（toLocaleDateString('ja-JP')）。読めなければ '' */
export function formatServerDate(v) {
  const t = parseServerTime(v);
  return t ? t.toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' }) : '';
}
